import { IConfig } from 'shared/map-search/types/config';

const initialState: IConfig = {
  newbuildingNewPromoPinsEnabled: false,
};

export const configReducer = (state = initialState) => {
  return state;
};
